// TODO: refactor jQuery --> ES
export default class Fluidpage {
	constructor(app) {
		this.app = app;

		/**
		 * object-fit-images
		 */
		objectFitImages();

		/**
		 * Hide/Show description
		 */
		$('.js-fluid-descr-btn').on("click", function () {
			$(this).prev('.js-fluid-descr').toggleClass("is-active")
			if ($(this).prev('.js-fluid-descr').hasClass("is-active")) {
				$(this).html($(this).data("close"));
			} else {
				$(this).html($(this).data("open"));
			}
		});


		/**
		 * Gallery element
		 */
		$('.js-fluid-gallery').photoSwipe(".js-fluid-image-link", {
			closeOnScroll: false,
			allowUserZoom: true
		});


		/**
		 * Video element (Popup)
		 */
		document.addEventListener('cookie-allowed-convenience-youtube', e => {
			document.querySelectorAll('.js-fluid-video-link').forEach(video => {
				video.setAttribute('href', video.dataset['href']);
				delete video.dataset['href'];
			})

			document.querySelectorAll('.js-youtube-nocookies').forEach(iframe => iframe.remove());

			//$('.js-fluid-video-link').modalVideo();
		});

		$('.js-fluid-video-link').on('click', e => {
			if (!~app.cookieManager.allowedCookies.indexOf('convenience-youtube')) {
				let iframe = document.createElement('iframe');
				iframe.src = `/s/frame_youtube_nocookies?key=${e.currentTarget.dataset['videoId']}`;
				iframe.height = `${window.innerHeight / 2}px`;
				iframe.classList.add('js-youtube-nocookies', 'popup', 'popup--center', 'popup--wide', 'is-active', 'cookie-conf-iframe');
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
		})


		/**
		 * Slider
		 */
		$('.js-fluid-slider-container').each(function (i) {
			if ($(this).children().length > 1) {
				const initSlider = () => {
					if (sliderWasInited) return;
					sliderWasInited = true

					console.debug('Init slider');

					// width hack
					// write width given by css fixed to slider to avoid wrong slider calculation
					$(this).closest('.js-fluid-slider').width(
						$(this).closest('.js-fluid-slider').width()
					);

					new Swiper($(this).closest('.js-fluid-slider'), {
						loop: true,
						wrapperClass: 'js-fluid-slider-container',
						slideClass: 'js-fluid-item',
						slideActiveClass: 'is-active',
						slideVisibleClass: 'is-active',

						navigation: {
							nextEl: '.js-fluid-slider-next',
							prevEl: '.js-fluid-slider-prev',
						},
						autoplay: {
							delay: 5000,
							disableOnInteraction: false, // Set to false and autoplay will not be disabled after user interactions (swipes), it will be restarted every time after interaction
						},
						pagination: {
							el: '.fluid-slider-pagination',
							clickable: true,
							bulletClass: 'fluid-slider-bullet',
							bulletActiveClass: 'is-active',
							clickableClass: 'is-clickable',
						},
					});
				}

				/*
				A workaround for the workaround ...
				If the image is not loaded, we cannot use its width.
				Wait until the first image is loaded, then the set width and init the Swiper.
				*/

				let imgTotal = 0;
				let imgLoaded = 0;
				let sliderWasInited = false;

				const images = $(this).find('img');

				if (images.length === 0) {
					// only other elements, init immediately.
					return initSlider();
				}

				images.each((i, node) => {
					imgTotal += 1;

					if (node.complete) {
						imgLoaded += 1;
					} else {
						node.addEventListener('load', e => {
							imgLoaded += 1;
							if (images.length === imgTotal && imgLoaded > 0) {
								initSlider();
							}
						}, {once: true})
					}

					if (images.length === imgTotal && imgLoaded > 0) {
						initSlider();
					}
				})
			}
		});

		/**
		 *  Callback Formular
		 *  show or hide the times, depending on selected date
		 */

		function checkdatetime() {
			let stmp = new Date();
			let now = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
			let slct = ($("input[name='callbackdate']").val() + "-" + $("select[name='callbacktime']").val().replace(":", "-")).split('-');
			let callbackstamp = new Date(slct[0], slct[1] - 1, slct[2], slct[3], slct[4]);
			let callbackdate = new Date(slct[0], slct[1] - 1, slct[2]);

			if (callbackdate.valueOf() === now.valueOf() && callbackstamp.valueOf() < stmp.valueOf()) {
				$("input[name='callbackdate']").removeClass("is-invalid");
				$("select[name='callbacktime']").addClass("is-invalid");
				$("select[name='callbacktime']").attr('disabled', false);
				$("select[name='callbacktime']").find("[data-def='hid']").prop('hidden', 'hidden');
				$('.js-callback-submit').attr('disabled', true)
			} else if (callbackdate.valueOf() === now.valueOf() && callbackstamp.valueOf() > stmp.valueOf()) {
				$("input[name='callbackdate']").removeClass("is-invalid");
				$("select[name='callbacktime']").removeClass("is-invalid");
				$("select[name='callbacktime']").attr('disabled', false);
				$("select[name='callbacktime']").find("[data-def='hid']").prop('hidden', 'hidden');
				$('.js-callback-submit').attr('disabled', false)
			} else if (callbackstamp.valueOf() < stmp.valueOf()) {
				$("input[name='callbackdate']").addClass("is-invalid");
				$("select[name='callbacktime']").addClass("is-invalid");
				$("select[name='callbacktime']").attr('disabled', true);
				$('.js-callback-submit').attr('disabled', true)
			} else if (callbackstamp.valueOf() > stmp.valueOf()) {
				$("input[name='callbackdate']").removeClass("is-invalid");
				$("select[name='callbacktime']").removeClass("is-invalid");
				$("select[name='callbacktime']").find("[data-def='hid']").prop('hidden', false);
				$("select[name='callbacktime']").attr('disabled', false);
				$('.js-callback-submit').attr('disabled', false);
			}

			// check if it is sat or sun
			if (callbackdate.getDay() == 6 || callbackdate.getDay() == 0) {
				$("input[name='callbackdate']").addClass("is-invalid is-weekend");
				$("select[name='callbacktime']").attr('disabled', true);
				$('.submit').attr('disabled', true);
			} else {
				$("input[name='callbackdate']").removeClass("is-weekend");
			}

		}

		const form = document.querySelector('.js-callback-form');

		if (form === null) {
			console.warn('Form not found!');
			return;
		} else {
			// found callback form, set Date to today because of caching...
			console.log("found form, set date.");
			let diff = 10;
			var now = new Date();
			var date = now.toISOString().split('T')[0];
			var time = new Date(now.getTime() + diff * 60000).toTimeString().slice(0, 4).concat("0");

			$("input[name='callbackdate']").val(date);
			$("input[name='callbackdate']").attr({"min": date});

			$("select[name='callbacktime']").val(time);
			checkdatetime();

		}


		form.addEventListener('submit', e => {

			if (!form.checkValidity() || !validateForm()) {
				e.preventDefault();
				return;
			}
			console.debug('onSubmit!');
		})

		function validateForm() {
			console.log("run validateForm");
			checkdatetime();
			return !($("select[name='callbacktime']").hasClass("is-invalid") || $("input[name='callbackdate']").hasClass("is-invalid"));
		}


		$("input[name='callbackdate']").change(function () {
			checkdatetime();
		});

		$("select[name='callbacktime']").change(function () {
			checkdatetime();
		});

	}
}
